/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { c as createSVGComponent } from '../utils-148d018d.js';
import '@carbon/icon-helpers';
import 'vue';

var ArrowUpLeft32 = createSVGComponent(ArrowUpLeft32, {
  "xmlns": "http://www.w3.org/2000/svg",
  "viewBox": "0 0 32 32",
  "fill": "currentColor",
  "width": 32,
  "height": 32
}, [{
  "elem": "path",
  "attrs": {
    "d": "M22 6L22 8 9.41 8 26 24.59 24.59 26 8 9.41 8 22 6 22 6 6 22 6z"
  }
}]);

export { ArrowUpLeft32 as default };
